import { AfterViewInit, Component, EventEmitter, Input, Output } from '@angular/core';
import { ITaskResponse } from '../../../modules/tasks/model/types';
import { map } from 'rxjs';
import { TaskDataService } from '../../../shared/services/task-data.service';

@Component({
  selector: 'app-hold-task',
  templateUrl: './hold-task.component.html',
  styleUrls: ['./hold-task.component.css']
})
export class HoldTaskComponent implements AfterViewInit  {

  @Input() holdTask: ITaskResponse;

  // Subscribe to statuses$ from service and filter for blocked statuses
  holdStatuses$: any;

  @Output() closePanelEmitter: EventEmitter<boolean> = new EventEmitter();
  @Output() onHoldEmitter: EventEmitter<any> = new EventEmitter();

  selectedHoldStatus: string = 'Open';
  comment: string = '';

  // Check if task is currently held (not in open status)
  get isReleasing(): boolean {
    return this.holdTask?.status?.toLowerCase() !== 'open';
  }

  constructor(private taskDataService: TaskDataService) {
    // Initialize holdStatuses$ observable
    this.holdStatuses$ = this.taskDataService.statuses$.pipe(
      map(result => {
        if (result && Array.isArray(result)) {
          // Filter statuses where isBlocked is true and map to name property
          return result.filter((status: any) => status.isBlocked === true)
                       .map((status: any) => status.name);
        }
        else
        {
          return [];
        }
      })
    );

    // Trigger statuses retrieval
    this.taskDataService.retrieveStatuses();
   }  onStatusChanged(e: any) {
    this.selectedHoldStatus = e.value;
  }

  onCommentChanged(e: any) {
    this.comment = e.value;
  }

  onDismiss() {
    this.closePanelEmitter.emit(true);
    this.resetForm();
  }

  onSubmit() {
    if (this.isFormValid()) {
      this.onHoldEmitter.emit({
        task: this.holdTask,
        status: this.selectedHoldStatus,
        comment: this.comment
      });
      this.resetForm();
    }
  }

  isFormValid(): boolean {
    if (this.isReleasing) {
      // For unholding, form is always valid (no hold status or comment required)
      return true;
    } else {
      // For holding, both hold status and comment are required
      return !!(this.selectedHoldStatus &&
                this.comment &&
                this.comment.trim().length > 0);
    }
  }

  resetForm() {
    this.selectedHoldStatus = '';
    this.comment = '';
  }

  ngAfterViewInit(): void {
    this.resetForm();
  }



}
